import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { Product } from '../produtos/produtos.modelview';
import { ActionSheetController } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

/**
 * Generated class for the DetalheAtlasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-detalhe-produto',
  templateUrl: 'detalhe-produto.html',
})
export class DetalheProdutoPage {

  model: Product
  temBula = true

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private inAppBrowser: InAppBrowser,
    private platform: Platform,
    public actionSheetCtrl: ActionSheetController) {

    this.model = navParams.get("model")

    this.temBula = this.model.bula_ampliada != undefined
      || this.model.bula_audio != undefined
      || this.model.bula_paciente != undefined
      || this.model.bula_profissional != undefined
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad DetalheAtlasPage');
  }


  presentActionSheet() {

    let bulas = []

    if (this.model.bula_paciente != undefined) {
      bulas.push({
        text: 'Bula Paciente',
        handler: () => {
          this.abrirDocumento(this.model.bula_paciente)
        }
      })
    }

    if (this.model.bula_ampliada != undefined) {
      bulas.push({
        text: 'Bula Ampliada',
        handler: () => {
          this.abrirDocumento(this.model.bula_ampliada)
        }
      })
    }

    if (this.model.bula_audio != undefined) {
      bulas.push({
        text: 'Bula Audio',
        handler: () => {
          this.abrirDocumento(this.model.bula_audio)
        }
      })
    }

    if (this.model.bula_profissional != undefined) {
      bulas.push({
        text: 'Bula do Profissional',
        handler: () => {
          this.abrirDocumento(this.model.bula_profissional)
        }
      })
    }

    const actionSheet = this.actionSheetCtrl.create({
      buttons: bulas
    });
    actionSheet.present();
  }

  abrirDocumento(url: string) {
    if (this.platform.is('core') || this.platform.is('mobileweb')) {
      window.open(url, '_system');
    } else {
      this.inAppBrowser.create(url, "_system", 'location=yes')
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/detalhe-produto/detalhe-produto.ts